import { render } from "./EmailVerified.vue?vue&type=template&id=47e02851"
import script from "./EmailVerified.vue?vue&type=script&lang=js"
export * from "./EmailVerified.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__